import { Badge, Btn, CopyBtn } from "../../components/ui";
import CopyCommandBtn from "./CopyCommandBtn";

const TelegramSection = ({ telegramLinked, telegramLoading, unlinkTelegram, telegramCode, generateTelegramCode, telegramError, telegramSuccess }) => (
        <div>
          <p style={{ fontFamily: "var(--font-mono)", fontSize: "10px", color: "var(--text-muted)", letterSpacing: "0.12em", marginBottom: 16 }}>TELEGRAM NOTIFICATIONS</p>
          <p style={{ fontSize: "14px", color: "var(--text-dim)", marginBottom: 24, lineHeight: 1.6 }}>
            Link your Telegram account to receive order updates, shipping notifications, and exclusive promotions via <a href="https://t.me/LimitlessDirectBot" target="_blank" rel="noopener noreferrer" style={{ color: "var(--green)", textDecoration: "none" }}>@LimitlessDirectBot</a>.
          </p>

          {telegramLinked === null ? (
            <p style={{ fontFamily: "var(--font-mono)", fontSize: "12px", color: "var(--text-muted)", letterSpacing: "0.1em" }}>LOADING…</p>
          ) : telegramLinked ? (
            <div style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: "var(--radius)", padding: 22 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
                <Badge color="var(--green)">LINKED</Badge>
                <span style={{ fontSize: "13px", color: "var(--text-dim)" }}>Your Telegram account is connected</span>
              </div>
              <p style={{ fontSize: "13px", color: "var(--text-dim)", marginBottom: 16 }}>
                You'll receive order updates and promotions via Telegram. Use <span style={{ fontFamily: "var(--font-mono)", fontSize: "12px" }}>/stop</span> in the bot to pause notifications.
              </p>
              <Btn small variant="ghost" onClick={unlinkTelegram} disabled={telegramLoading}>
                {telegramLoading ? "Unlinking…" : "Unlink Telegram"}
              </Btn>
            </div>
          ) : (
            <div style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: "var(--radius)", padding: 22 }}>
              <p style={{ fontSize: "14px", color: "var(--text)", marginBottom: 16, fontWeight: 600 }}>Link your account in 2 steps:</p>
              <div style={{ display: "flex", flexDirection: "column", gap: 12, marginBottom: 20 }}>
                <div style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
                  <span style={{ fontFamily: "var(--font-mono)", fontSize: "13px", color: "var(--amber)", fontWeight: 700, minWidth: 20 }}>1.</span>
                  <span style={{ fontSize: "13px", color: "var(--text-dim)" }}>Generate a one-time code below</span>
                </div>
                <div style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
                  <span style={{ fontFamily: "var(--font-mono)", fontSize: "13px", color: "var(--amber)", fontWeight: 700, minWidth: 20 }}>2.</span>
                  <span style={{ fontSize: "13px", color: "var(--text-dim)" }}>Copy the command below, open <a href="https://t.me/LimitlessDirectBot" target="_blank" rel="noopener noreferrer" style={{ color: "var(--green)", textDecoration: "none" }}>@LimitlessDirectBot</a>, and paste it</span>
                </div>
              </div>

              {telegramCode ? (
                <div>
                  <label style={{ fontFamily: "var(--font-mono)", fontSize: "10px", color: "var(--text-muted)", letterSpacing: "0.08em", display: "block", marginBottom: 6 }}>YOUR LINK CODE (expires in 10 minutes)</label>
                  <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 16 }}>
                    <input readOnly value={telegramCode} style={{ fontFamily: "var(--font-mono)", fontSize: "18px", letterSpacing: "0.2em", fontWeight: 700, padding: "10px 14px", width: 160, textAlign: "center" }} />
                    <CopyBtn value={telegramCode} />
                    <Btn small onClick={generateTelegramCode} disabled={telegramLoading}>New Code</Btn>
                  </div>
                  <CopyCommandBtn code={telegramCode} />
                </div>
              ) : (
                <Btn onClick={generateTelegramCode} disabled={telegramLoading}>
                  {telegramLoading ? "Generating…" : "Generate Link Code"}
                </Btn>
              )}
            </div>
          )}

          {telegramError && <p style={{ color: "var(--red)", fontSize: "12px", fontFamily: "var(--font-mono)", marginTop: 12 }}>{telegramError}</p>}
          {telegramSuccess && <p style={{ color: "var(--green)", fontSize: "12px", fontFamily: "var(--font-mono)", marginTop: 12 }}>{telegramSuccess}</p>}
        </div>
);

export default TelegramSection;
